// @flow

import { FlexProps, TextProps } from "@chakra-ui/react";
import * as colors from "src/styles/constants/colors";

export const container: FlexProps = {
  border: "1px",
  borderColor: "unifize_sky",
  width: "280px",
  alignItems: "center",
  justifyContent: "space-between",
  px: 2,
  py: 1,
};

export const fileIcon = {
  width: "18px",
  height: "18px",
};

export const fileName: TextProps = {
  my: 0,
  isTruncated: true,
  maxWidth: "120px",
  fontSize: "14px",
};

export const fileSize: TextProps = {
  my: 0,
  fontSize: "14px",
};

export const removeIcon = {
  size: "10px",
  cursor: "pointer",
  color: colors.inkLighter,
};
